function modals() {
    const modal = document.querySelector('.privacy-modal');
    const modalContents = modal ? modal.querySelector('.privacy-modal--contents') : null;
    const closeControl = modal ? modal.querySelector('.privacy-modal--header--close') : null;

    if (!modal || !modalContents) {
        return;
    }

    const getResponseDocument = function (html) {
      return new DOMParser().parseFromString(html, "text/html");
    };

    const getContentNode = function (doc) {
        const selectors = [
          ".policy-content",
          ".policy-content--content",
          "main#main.content",
          "#main .content",
          "#main",
          "main",
          "body",
        ];

        for (let i = 0; i < selectors.length; i += 1) {
            const node = doc.querySelector(selectors[i]);
            if (node) {
                return node;
            }
        }

        return null;
    };

    const getModalHtml = function (doc, fallbackHtml) {
      const contentNode = getContentNode(doc);

      if (!contentNode) {
        return fallbackHtml;
      }

      if (
        contentNode.matches(".policy-content") ||
        contentNode.matches(".policy-content--content")
      ) {
        return contentNode.outerHTML;
      }

      return contentNode.innerHTML;
    };

    const loadModalContent = async function (url) {
        const response = await fetch(url, {
          method: "GET",
          cache: "no-store",
          credentials: "same-origin",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          },
        });

        if (!response.ok) {
            throw new Error('Failed to fetch modal content.');
        }

        const html = await response.text();
        const doc = getResponseDocument(html);
        const modalHtml = getModalHtml(doc, html);

        if (!modalHtml || !modalHtml.trim()) {
          throw new Error("Could not find content in modal source page.");
        }

        modalContents.innerHTML = modalHtml;
    };

    const openModal = function () {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
    };

    const closeModal = function () {
        modal.classList.remove('active');
        document.body.style.overflow = '';
    };

    if (closeControl) {
        closeControl.addEventListener('click', function (event) {
            event.preventDefault();
            closeModal();
        });
    }

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
            closeModal();
        }
    });

    document.addEventListener('click', async function (event) {
        const link = event.target.closest('a.modal-link');

        if (!link) {
            return;
        }

        event.preventDefault();

        const url = link.getAttribute('href');
        if (!url) {
            return;
        }

        const absoluteUrl = new URL(url, window.location.href);
        if (absoluteUrl.origin !== window.location.origin) {
            window.location.href = absoluteUrl.href;
            return;
        }

        modalContents.innerHTML = '<p>Loading...</p>';

        try {
            await loadModalContent(absoluteUrl.href);
            openModal();
        } catch (error) {
            console.error("Modal content load failed:", error);
            modalContents.innerHTML = '<p>Sorry, we could not load this content right now.</p>';
            openModal();
        }
    });
}


modals();